import _ from "lodash";
import React from "react";
import classes from "./Header.scss";
import { ChevronIcon } from "SvgComponents";
import { colors } from "Constants";
import I18nHOC from "UIComponents/I18nHOC";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
class Header extends React.PureComponent {
  render() {
    const {
      title,
      subTitle = "",
      onCloseClick,
      showBack,
      onBackClick,
      showPreview,
      t,
      titleTextStyle,
      subTitleTextStyle,
      leftContainerStyles,
      rightContainerStyles,
      showCustomHeaderIcon = false,
      customHeaderIconStyle,
      customHeaderIcon, // Can be any react component which works as an icon, (i.e. Avatar, svg Icon, etc)
      titleContainerStyle = {},
      modalHeaderContainerStyle = {},
    } = this.props;
    return (
      <div
        className={classes.container}
        style={{ ...modalHeaderContainerStyle }}
      >
        {!!showBack && (
          <div className={classes.backContainer} onClick={onBackClick}>
            <ChevronIcon fill={colors.salmon60} />
            <div className={classes.backBtnText}>{t("common:back")}</div>
          </div>
        )}
        <div style={titleContainerStyle} className={classes.titleContainer}>
          <div style={leftContainerStyles} className={classes.leftContainer}>
            {showCustomHeaderIcon && (
              <div style={customHeaderIconStyle} className={classes.customIcon}>
                {customHeaderIcon}
              </div>
            )}
            <div className={classes.titleTextContainer}>
              <div style={titleTextStyle} className={classes.titleText}>
                {title}
              </div>
              {!_.isEmpty(subTitle) && (
                <div style={subTitleTextStyle} className={classes.subTitleText}>
                  {subTitle}
                </div>
              )}
            </div>
          </div>
          <div style={rightContainerStyles} className={classes.rightContainer}>
            {!!showPreview && (
              <div className={classes.previewButton}>{t("common:preview")}</div>
            )}
            {!!showPreview && <div className={classes.separatorline} />}
            <IconButton
              icon={<CloseOutlined size={"x-small"} />}
              variant={"plain"}
              size={"medium"}
              onClick={onCloseClick}
              testId={"journal-postcreation-tagmodal"}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: "common" })(Header);
